import React from 'react';
import { useTranslation } from 'react-i18next';
import ParticipantStatusBadges from '../ParticipantStatusBadges';
import {
  FooterContentWrap,
  FooterName,
  FooterStatusWrap,
} from './style';

const stripYouSuffix = (name = '', youLabel = 'You') => {
  const escapedYouLabel = String(youLabel).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  return `${name || ''}`.replace(new RegExp(`\\s*\\(${escapedYouLabel}\\)\\s*$`, 'i'), '').trim();
};

const FrameFooterContent = ({
  user,
  displayName,
  showRemoteMutedOnly = false,
  showStatus = true,
}) => {
  const { t } = useTranslation();
  const youLabel = t('VideoChatV2.you');
  const cleanName = stripYouSuffix(displayName || user?.fullName || user?.name || t('VideoChatV2.participant'), youLabel);
  const text = user?.self ? `${cleanName} (${youLabel})` : cleanName;

  return (
    <FooterContentWrap>
      <FooterName>{text}</FooterName>
      {showStatus && !user?.self ? (
        <FooterStatusWrap>
          <ParticipantStatusBadges
            attendeeId={user?.attendeeId}
            joined={user?.joined}
            iconOnly
            showLabels={showRemoteMutedOnly}
            showOnlyMutedMic={showRemoteMutedOnly}
            showOnlyMic
            providedMuted={user?.muted}
            providedVideoEnabled={user?.cameraOn}
          />
        </FooterStatusWrap>
      ) : null}
    </FooterContentWrap>
  );
};

export default FrameFooterContent;
